var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconKakaotalk2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1.5C3.43858 1.5 0.75 4.86254 0.75 7.70729C0.75 9.83885 2.17817 11.7191 4.35342 12.8364L3.43858 16.0923C3.357 16.381 3.69525 16.6101 3.95467 16.444L7.96692 13.8639C8.30517 13.8959 8.64983 13.9146 9 13.9146C13.5558 13.9146 17.25 11.1356 17.25 7.70729C17.25 4.86254 14.25 1.5 9 1.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKakaotalk2);
export default __webpack_public_path__ + "static/media/icon-kakaotalk-2.bb5109d370ec70416cf58c11eb5d80bf.svg";
export { ForwardRef as ReactComponent };